
<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <h3>Unit</h3>
                        </div>
                        <div class="col-sm-6 d-flex justify-content-end">
                            <button type="button"  data-bs-toggle="modal" data-bs-target="#opportunity" class="btn btn-icon"><i class="ri-add-line"></i></button>
                        </div>
                    </div>
                    <div class="canvas-data">
                        <div class="canvas-table">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Rate per hour</th>
                                        <th>Unit</th>
                                        <th>2020 Price</th>
                                        <th>2021 Price</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>TB LD</td>
                                        <td>Hour</td>
                                        <td>$582</td>
                                        <td>$528</td>
                                        <td>
                                            <div class="table-action">
                                                <button class="action-btn"><i class="ri-more-2-fill"></i></button>
                                                <div class="action-items">
                                                    <div class="edit">
                                                        <button>
                                                            <span><i class="ri-pencil-line"></i></span>
                                                            <span>Edit</span>
                                                        </button>
                                                    </div>
                                                    <div class="delete">
                                                        <button>
                                                            <span><i class="ri-delete-bin-5-line"></i></span>
                                                            <span>Delete</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>TB LD</td>
                                        <td>Hour</td>
                                        <td>$582</td>
                                        <td>$528</td>
                                        <td>
                                            <div class="table-action">
                                                <button class="action-btn"><i class="ri-more-2-fill"></i></button>
                                                <div class="action-items">
                                                    <div class="edit">
                                                        <button>
                                                            <span><i class="ri-pencil-line"></i></span>
                                                            <span>Edit</span>
                                                        </button>
                                                    </div>
                                                    <div class="delete">
                                                        <button>
                                                            <span><i class="ri-delete-bin-5-line"></i></span>
                                                            <span>Delete</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>TB LD</td>
                                        <td>Hour</td>
                                        <td>$582</td>
                                        <td>$528</td>
                                        <td>
                                            <div class="table-action">
                                                <button class="action-btn"><i class="ri-more-2-fill"></i></button>
                                                <div class="action-items">
                                                    <div class="edit">
                                                        <button>
                                                            <span><i class="ri-pencil-line"></i></span>
                                                            <span>Edit</span>
                                                        </button>
                                                    </div>
                                                    <div class="delete">
                                                        <button>
                                                            <span><i class="ri-delete-bin-5-line"></i></span>
                                                            <span>Delete</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </article>
</main>
  
<!-- Create new Opportunity -->
<div class="modal fade" id="opportunity" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Create new Opportunity</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="input">
                        <div class="input-item">
                            <input type="text" required>
                            <label class="floating-label">Opportunity Name</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input type="text" required>
                            <label class="floating-label">Account Name</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input type="text" required>
                            <label class="floating-label">Start Date</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input type="text" required>
                            <label class="floating-label">End Date</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input type="text" required>
                            <label class="floating-label">Submission Deadline</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input type="text" required>
                            <label class="floating-label">Gross Price</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input type="text" required>
                            <label class="floating-label">Probabilty</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input type="text" required>
                            <label class="floating-label">Status</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary">Create Opprtunity</button>
                </div>
            </form>
        </div>
    </div>
</div>